module.exports = __webpack_public_path__ + "static/media/ShipstonLanding.77d78b03.png";